/* Mark's Outdoors — live store-hours status. Port of getStoreStatus() +
   OpenStatus from site-data.ts / home-sections.tsx.
   Reads day rows from [data-mo-hours] (7 children with data-open / data-close
   as minutes-from-midnight, blank = closed), highlights today, and fills every
   [data-mo-open-status] badge. Refreshes every minute. */
(function () {
  'use strict';

  function formatMinutes(min) {
    var h = Math.floor(min / 60);
    var m = min % 60;
    var suffix = h < 12 ? 'AM' : 'PM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return m === 0 ? h12 + suffix : h12 + ':' + String(m).padStart(2, '0') + suffix;
  }

  function readHours() {
    var host = document.querySelector('[data-mo-hours]');
    if (!host) return null;
    var rows = host.querySelectorAll('[data-day-index]');
    if (rows.length !== 7) return null;
    var days = new Array(7);
    rows.forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-day-index'), 10);
      var open = row.getAttribute('data-open');
      var close = row.getAttribute('data-close');
      days[idx] = {
        row: row,
        day: row.getAttribute('data-day-name') || '',
        open: open === '' || open === null ? null : parseInt(open, 10),
        close: close === '' || close === null ? null : parseInt(close, 10)
      };
    });
    return days;
  }

  function getStatus(days, now) {
    var day = now.getDay();
    var nowMin = now.getHours() * 60 + now.getMinutes();
    var today = days[day];
    if (today.open != null && today.close != null && nowMin >= today.open && nowMin < today.close) {
      return { isOpen: true, badge: 'OPEN · TIL ' + formatMinutes(today.close) };
    }
    if (today.open != null && nowMin < today.open) {
      return { isOpen: false, badge: 'CLOSED · OPENS ' + formatMinutes(today.open) };
    }
    for (var i = 1; i <= 7; i++) {
      var d = days[(day + i) % 7];
      if (d.open != null) {
        var abbrev = d.day.slice(0, 3).toUpperCase();
        return { isOpen: false, badge: 'CLOSED · OPENS ' + abbrev + ' ' + formatMinutes(d.open) };
      }
    }
    return { isOpen: false, badge: 'CLOSED' };
  }

  function update() {
    var days = readHours();
    var now = new Date();
    var badges = document.querySelectorAll('[data-mo-open-status]');
    if (days) {
      var status = getStatus(days, now);
      badges.forEach(function (b) {
        b.classList.toggle('is-open', status.isOpen);
        b.classList.toggle('is-closed', !status.isOpen);
        var label = b.querySelector('[data-status-label]');
        if (label) label.textContent = status.badge;
      });
      days.forEach(function (d, i) {
        d.row.classList.toggle('is-today', i === now.getDay());
        var tag = d.row.querySelector('[data-today-tag]');
        if (tag) tag.hidden = i !== now.getDay();
      });
    }
  }

  function start() {
    update();
    window.setInterval(update, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', update);
})();
